export type ClinicPatientOption = {
  _id: string
  fullName?: string
  regNo?: string
  mobileNo?: string
  dob?: string
  gender?: string
  address?: string
}

function ageFromDob(dob: string | Date | undefined) {
  if (!dob) return null
  const d = new Date(dob)
  if (Number.isNaN(d.getTime())) return null
  const now = new Date()
  let age = now.getFullYear() - d.getFullYear()
  const monthDiff = now.getMonth() - d.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < d.getDate())) {
    age -= 1
  }
  return age >= 0 ? age : null
}

export function formatPatientLabel(p: ClinicPatientOption) {
  const name = p.fullName?.trim() || 'Patient'
  const reg = p.regNo?.trim()
  return reg ? `${name} (${reg})` : name
}

export function formatPatientMeta(p: ClinicPatientOption) {
  const parts: string[] = []
  const age = ageFromDob(p.dob)
  if (age != null) parts.push(`${age} yrs`)
  if (p.gender?.trim()) parts.push(p.gender.trim())
  if (p.mobileNo?.trim()) parts.push(p.mobileNo.trim())
  if (p.regNo?.trim()) parts.push(`Reg: ${p.regNo.trim()}`)
  return parts.join(' · ')
}
